import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { routeUrlGenerator } from '@bg-shared/utils/routeUrlGenerator';
import { sessionStore } from '@bg-shared/business/Session';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';

export const useCustomEventsRedirects = (): ((routeName: string) => void) => {
    const navigate = useNavigate();

    const getUrl = useCallback(
        (routeName: string): string | null => {
            const routeId = Number(routeName);

            if (partnerSettingsStore.availableGamesIds.includes(routeId)) {
                return routeUrlGenerator.getGameUrl(routeId);
            }

            if (!Number.isNaN(routeId)) {
                return routeUrlGenerator.getGameUrl();
            }

            return null;
        },
        [sessionStore.partnerCode, partnerSettingsStore.availableGamesIds.length],
    );

    return useCallback(
        (routeName: string) => {
            const url = getUrl(routeName);

            if (url) {
                navigate(url);
            }
        },
        [getUrl],
    );
};
